import { render, staticRenderFns } from "./StockCalcTable2.vue?vue&type=template&id=5ff57e34"
import script from "./StockCalcTable2.vue?vue&type=script&lang=js"
export * from "./StockCalcTable2.vue?vue&type=script&lang=js"
import style0 from "./StockCalcTable2.vue?vue&type=style&index=0&id=5ff57e34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports